export enum ENUM_TRANSACTION_ACTION {
  DEBIT = 'Debit',
  CREDIT = 'Credit'
}

export type TransactionType = {
  amount: string;
  created_at: string;
  deleted: boolean;
  description: string;
  id: string;
  reason: string | null;
  reference: string;
  transaction_action: ENUM_TRANSACTION_ACTION;
  transaction_status: string;
  transaction_type: string;
  updated_at: string;
};
